import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import styled from "styled-components"
import BackgroundImage from "gatsby-background-image"
import Button from "../../Button/button"
import { motion } from "framer-motion"

const Banner = ({ company }) => {
  const data = useStaticQuery(graphql`
    query {
      file(relativePath: { eq: "bg-home-hero-bits.png" }) {
        childImageSharp {
          fluid(quality: 90, maxWidth: 1920) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)

  const variants = {
    visible: { opacity: 1, y: 0 },
    hidden: { opacity: 0, y: 20 },
  }

  const getBanner = _ => {
    if (company) {
      return (
        <>
          <motion.h1
            initial="hidden"
            animate="visible"
            variants={variants}
            transition={{ ease: "easeOut", duration: 0.8, delay: 1 }}
          >
            Codehall for <span>Companies</span>
          </motion.h1>
          <motion.div
            initial="hidden"
            animate="visible"
            variants={variants}
            transition={{ ease: "easeOut", duration: 0.8, delay: 1.5 }}
          >
            <p>
            Give your employees’ young ones an edge in today’s world.
            </p>
            <Button
              cta="Book a demo"
              label="Banner Book a demo"
              anchor={true}
              href="https://form.jotform.com/202457215984258"
            />
          </motion.div>
        </>
      )
    } else {
      return (
        <>
          <motion.h1
            initial="hidden"
            animate="visible"
            variants={variants}
            transition={{ ease: "easeOut", duration: 0.8, delay: 1 }}
          >
            Prepare them for the <span>world</span> of <span>tomorrow</span>.
          </motion.h1>
          <motion.div
            initial="hidden"
            animate="visible"
            variants={variants}
            transition={{ ease: "easeOut", duration: 0.8, delay: 1.5 }}
          >
            <p>
              Teaching your child how to code in the most fun and educational
              way.
            </p>
            <Button
              cta="Start your free session"
              label="Banner Start your free session"
              anchor={true}
              href="https://form.jotform.com/202457215984258"
            />
          </motion.div>
        </>
      )
    }
  }

  return (
    <BannerWrapper>
      <BackgroundImage
        className="hero-image"
        id="#bits-bg"
        fluid={data.file.childImageSharp.fluid}
        style={{ backgroundSize: "contain", height: "100%", width: "100%" }}
      >
        <div className="hero-content">{getBanner()}</div>
      </BackgroundImage>
    </BannerWrapper>
  )
}

const BannerWrapper = styled.section`
  font-size: 16px;
  .hero-image {
    width: 100%;
    background-color: transparent;
    background-size: contain;
    background-position: center center;
    &::before,
    &::after {
      @media (max-width: 1200px) {
        background: none !important;
      }
    }
  }

  .hero-content {
    text-align: center;
    height: 100%;
    width: 100%;
    padding: 0 20px;
    padding: 132px 20px 64px 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-left: auto;
    margin-right: auto;

    h1 {
      font-size: 3rem;
      line-height: 4rem;
      font-family: "Poppins-Bold";
      font-weight: 700;
      word-wrap: break-word;
      margin-bottom: 0;

      span {
        background: -webkit-linear-gradient(45deg, #03a9f4, #f441a5);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }

    p {
      margin-top: 24px;
      margin-bottom: 2rem;
      line-height: 1.5;
      font-size: 1.125rem;
      margin: 32px auto 32px;
      max-width: 550px;

      @media (min-width: 768px) {
        font-size: 1.125rem;
      }

      @media (min-width: 1200px) {
        .hero-content {
          width: 1000px;
        }
      }
    }

    button,
    .anchor {
      margin: 0 auto;
    }

    @media (min-width: 768px) {
      max-width: 880px;

      h1 {
        font-size: 4.375rem;
        line-height: 5rem;
      }
    }

    @media (min-width: 1200px) {
      max-width: 1000px;
      h1 {
        font-size: 5.375rem;
        line-height: 6rem;
      }
    }
  }
`

export default Banner
